import { useState } from "react";
import { FaShareAlt } from "react-icons/fa";
import { useOutletContext, useParams } from "react-router-dom";
import SharePropertyModal from "../../../../Components/SharePropertyModal/SharePropertyModal";
import { APP_BASE_URL } from "../../../../Utils/constants";
import { getUserData, withAuthCheck } from "../../../../Utils/localStorageUtils";
import { addInterestedUser } from "../../../../services/propertyService";
import useAsyncAction from "../../../../hooks/usePropertyAction";
import useCustomNavigate from "../../../../hooks/useCustomNavigate";

const FlatListing = () => {
  const { propertyData } = useOutletContext();
  const { propertyId } = useParams();
  const {goTo} = useCustomNavigate()

  const userData = getUserData();
  const [isShareModalOpen, setShareModalOpen] = useState(false); // ✅ Modal State
  // Extracting required details
  const { basicDetails, locationDetails, aboutProperty } = propertyData;
  const propertyType = basicDetails?.additionalOption?.value || "Property";
  const city = locationDetails?.city || "";
  const locality = locationDetails?.locality || "";
  const subLocality = locationDetails?.subLocality || "";
  const bedrooms = aboutProperty?.roomDetails?.bedrooms || "-";
  const bathrooms = aboutProperty?.roomDetails?.bathrooms || "-";
  const balconies = aboutProperty?.roomDetails?.balconies || "-";


  const { execute, loading, data } = useAsyncAction(addInterestedUser); // ✅ Use the reusable hook

    const handleInterestClick = async (e) => {
      e.preventDefault();
      await withAuthCheck(async (userData) => {
        const response = await execute(propertyId, userData._id);
  
        if (response.success) {
          console.log("User is interested!");
        }
      })(goTo); // ✅ Pass `navigate`
    };


  return (
    <div className="flex items-center justify-between p-4 border rounded-lg ">
      <span className="text-gray-700 text-lg font-medium">
        {bedrooms} BHK {propertyType} For {basicDetails?.lookingTo} in{" "}
        {locality ? `${locality}, ` : ""}
        {city ? `${city}` : ""}
      </span>
      <div className="flex items-center space-x-4">
        <FaShareAlt
          className="text-gray-500 cursor-pointer hover:text-gray-700"
          size={20}
          onClick={() => setShareModalOpen(true)} // ✅ Open modal on click
        />
        <button
          onClick={handleInterestClick}
          className="bg-red-500 text-white px-4 py-2 rounded-lg hover:bg-red-600"
          disabled={loading} // ✅ Disable while loading
        >
          {loading ? "Processing..." : data?.success ? "Already Interested" : "Contact Owner"}
        </button>
      </div>

      {/* ✅ Share Property Modal */}
      {isShareModalOpen && (
        <SharePropertyModal
          isOpen={isShareModalOpen}
          onClose={() => setShareModalOpen(false)}
          shareUrl={`${APP_BASE_URL}/property/${propertyId}`} // ✅ Dynamic property link
        />
      )}

    </div>
  );
};

export default FlatListing;
